import { render, staticRenderFns } from "./forceClose.vue?vue&type=template&id=7155f178&scoped=true"
import script from "./forceClose.vue?vue&type=script&lang=js"
export * from "./forceClose.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7155f178",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7155f178')) {
      api.createRecord('7155f178', component.options)
    } else {
      api.reload('7155f178', component.options)
    }
    module.hot.accept("./forceClose.vue?vue&type=template&id=7155f178&scoped=true", function () {
      api.rerender('7155f178', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/invoiceCenter/mdfe/cmp/forceClose.vue"
export default component.exports